import { createFileRoute } from "@tanstack/react-router";

import { TasksPage } from "../../../workspaces/work-atlas/pages/TasksPage";

/** `task` opens one task by any of its statements' O*NET ids: where a project's task links. */
type WorkTasksSearch = { readonly task?: number };

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas/tasks")({
  validateSearch: (search: Record<string, unknown>): WorkTasksSearch => {
    const task = Number(search.task);
    return Number.isSafeInteger(task) && task > 0 ? { task } : {};
  },
  component: WorkTasksRoute,
});

function WorkTasksRoute() {
  const { task } = Route.useSearch();
  return <TasksPage task={task === undefined ? undefined : BigInt(task)} />;
}
